<ng-container *ngIf="appointment">
  <ng-container *ngIf="!workflow; else workflowTemplate">
    <button
      *appHasPermission="'appointment.edit'"
      mat-icon-button
      [matMenuTriggerFor]="eligibilityMenu"
      [matTooltip]="tooltipText$ | async | translate"
      matTooltipPosition="above"
      (click)="$event.stopPropagation()"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        *ngIf="inProgress">
        <mat-progress-spinner color="primary" mode="indeterminate" diameter="25"></mat-progress-spinner>
      </div>
      <div class="icon-container">
        <!-- Status icon for primary insurance-->
        <mat-icon
          *ngIf="!inProgress"
          [ngClass]="[
        eligibilityStatusColor(appointment.eligibilityPrimaryStatus),
        appointment.eligibilitySecondaryStatus ? 'primary-icon' : '',
      ]">
          <ng-container *ngIf="appointment.eligibilityPrimaryStatus === ELIGIBILITY_STATUS.ACTIVE">
            gpp_good
          </ng-container>
          <ng-container *ngIf="appointment.eligibilityPrimaryStatus === ELIGIBILITY_STATUS.INACTIVE">
            gpp_bad
          </ng-container>
          <ng-container
            *ngIf="
        appointment.eligibilityPrimaryStatus !== ELIGIBILITY_STATUS.ACTIVE &&
        appointment.eligibilityPrimaryStatus !== ELIGIBILITY_STATUS.INACTIVE">
            shield
          </ng-container>
        </mat-icon>
        <!-- Status icon for secondary insurance-->
        <mat-icon
          class="secondary-icon"
          *ngIf="appointment.eligibilityDetails?.secondary?.status && !inProgress"
          [ngClass]="eligibilityStatusColor(appointment.eligibilitySecondaryStatus)">
          <ng-container *ngIf="appointment.eligibilitySecondaryStatus === ELIGIBILITY_STATUS.ACTIVE">
            gpp_good
          </ng-container>
          <ng-container *ngIf="appointment.eligibilitySecondaryStatus === ELIGIBILITY_STATUS.INACTIVE">
            gpp_bad
          </ng-container>
          <ng-container
            *ngIf="
          appointment.eligibilitySecondaryStatus !== ELIGIBILITY_STATUS.ACTIVE &&
          appointment.eligibilitySecondaryStatus !== ELIGIBILITY_STATUS.INACTIVE"
          >
            shield
          </ng-container>
        </mat-icon>
      </div>
    </button>

    <mat-menu #eligibilityMenu="matMenu">
      <button
        mat-menu-item
        *ngIf="appointment.eligibilityPrimaryId"
        (click)="goto(appointment.url)"
        [queryParams]="{ type: 'eligibility' }"
      >
        <mat-icon>launch</mat-icon>
        <span>{{ 'eligibility.icon.view' | translate }}</span>
      </button>
      <button
        mat-menu-item
        [disabled]="isActive(appointment.eligibilityPrimaryStatus)"
        (click)="markInsuranceAs('primary', 'active')"
      >
        <mat-icon class="green">verified_user</mat-icon>
        <span>{{ 'eligibility.icon.primary-active' | translate }}</span>
      </button>
      <button
        mat-menu-item
        [disabled]="appointment.eligibilityPrimaryStatus === ELIGIBILITY_STATUS.INACTIVE"
        (click)="markInsuranceAs('primary', 'inactive')"
      >
        <mat-icon class="yellow">remove_moderator</mat-icon>
        <span>{{ 'eligibility.icon.primary-inactive' | translate }}</span>
      </button>
      <button
        mat-menu-item
        [matMenuTriggerFor]="secondaryInsuranceMenu"
      >
        <mat-icon>shield</mat-icon>
        {{ 'common.secondary' | translate }}
      </button>
    </mat-menu>

    <mat-menu #secondaryInsuranceMenu="matMenu">
      <button
        mat-menu-item
        [disabled]="isActive(appointment.eligibilitySecondaryStatus)"
        (click)="markInsuranceAs('secondary', 'active')"
      >
        <mat-icon class="green">verified_user</mat-icon>
        <span>{{ 'eligibility.icon.active' | translate }}</span>
      </button>
      <button
        mat-menu-item
        [disabled]="appointment.eligibilitySecondaryStatus === ELIGIBILITY_STATUS.INACTIVE"
        (click)="markInsuranceAs('secondary', 'inactive')"
      >
        <mat-icon class="yellow">remove_moderator</mat-icon>
        <span>{{ 'eligibility.icon.inactive' | translate }}</span>
      </button>
    </mat-menu>
  </ng-container>
  <ng-template #workflowTemplate>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <mat-icon
        [ngClass]="eligibilityStatusColor(appointment.eligibilityPrimaryStatus)"
        fxFlex="25px"
      >
        <ng-container *ngIf="appointment.eligibilityPrimaryStatus === ELIGIBILITY_STATUS.ACTIVE">
          gpp_good
        </ng-container>
        <ng-container *ngIf="appointment.eligibilityPrimaryStatus === ELIGIBILITY_STATUS.INACTIVE">
          gpp_bad
        </ng-container>
        <ng-container
          *ngIf="
        appointment.eligibilityPrimaryStatus !== ELIGIBILITY_STATUS.ACTIVE &&
        appointment.eligibilityPrimaryStatus !== ELIGIBILITY_STATUS.INACTIVE">
          shield
        </ng-container>
      </mat-icon>
      <span>{{ tooltipText$ | async | translate }}</span>
    </div>
  </ng-template>
</ng-container>

<button *ngIf="status" mat-stroked-button>
  <mat-icon [ngClass]="eligibilityStatusColor(this.status)">
    <ng-container *ngIf="status === ELIGIBILITY_STATUS.ACTIVE">
      gpp_good
    </ng-container>
    <ng-container *ngIf="status === ELIGIBILITY_STATUS.INACTIVE">
      gpp_bad
    </ng-container>
    <ng-container *ngIf="status !== ELIGIBILITY_STATUS.ACTIVE && status !== ELIGIBILITY_STATUS.INACTIVE">
      shield
    </ng-container>
  </mat-icon>
  {{ eligibilityDisplayStatus(status) | translate }}
</button>
